export default __webpack_public_path__ + "static/media/birfcase.2365f444.svg";